import React from "react";

const DataExtractLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 360 360"
      width="80"
      height="60"
    >
      <path
        fill="#FFFFFF"
        stroke="#09222D"
        strokeWidth={5}
        strokeMiterlimit={10}
        d="M80.9,222.9H31.7c-2.4,0-4.3,1.9-4.3,4.3v77.4c0,2.4,1.9,4.3,4.3,4.3h49.3c2.4,0,4.3-1.9,4.3-4.3v-77.4
   C85.2,224.8,83.3,222.9,80.9,222.9z"
      />
      <path
        fill="#3872B9"
        d="M166.8,157.6h-49.3c-2.4,0-4.3,1.9-4.3,4.3v142.7c0,2.4,1.9,4.3,4.3,4.3h49.3c2.4,0,4.3-1.9,4.3-4.3V161.9
   C171.1,159.6,169.1,157.6,166.8,157.6z"
      />
      <path
        fill="#3872B9"
        d="M329.6,114.5h-49.3c-2.4,0-4.3,1.9-4.3,4.3v185.8c0,2.4,1.9,4.3,4.3,4.3h49.3c2.4,0,4.3-1.9,4.3-4.3V118.8
   C333.9,116.4,331.9,114.5,329.6,114.5z"
      />
      <path
        fill="#FFFFFF"
        stroke="#09222D"
        strokeWidth={5}
        strokeMiterlimit={10}
        d="M251.2,193.8H202c-2.4,0-4.3,1.9-4.3,4.3v106.5c0,2.4,1.9,4.3,4.3,4.3h49.3c2.4,0,4.3-1.9,4.3-4.3V198.1
   C255.5,195.7,253.6,193.8,251.2,193.8z"
      />
      <polyline
        fill="none"
        stroke="#09222D"
        strokeWidth={5}
        strokeMiterlimit={10}
        points="54.5,157.6 142.1,100.9 226.6,131 304.9,69.5 "
      />
      <circle
        fill="#3872B9"
        stroke="#FFFFFF"
        strokeWidth={5}
        strokeMiterlimit={10}
        cx="54.5"
        cy="157.6"
        r="18.3"
      />
      <circle
        fill="#3872B9"
        stroke="#FFFFFF"
        strokeWidth={5}
        strokeMiterlimit={10}
        cx="142.1"
        cy="100.9"
        r="18.3"
      />
      <circle
        fill="#3872B9"
        stroke="#FFFFFF"
        strokeWidth={5}
        strokeMiterlimit={10}
        cx="226.6"
        cy="131"
        r="18.3"
      />
      <circle
        fill="#3872B9"
        stroke="#FFFFFF"
        strokeWidth={5}
        strokeMiterlimit={10}
        cx="304.9"
        cy="69.5"
        r="18.3"
      />
    </svg>
  );
};

export default DataExtractLogo;
